import { render, staticRenderFns } from "./BlendSettingsCreateConfirmModal.vue?vue&type=template&id=4006164c"
import script from "./BlendSettingsCreateConfirmModal.vue?vue&type=script&lang=js"
export * from "./BlendSettingsCreateConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports